/* eslint new-cap: 0 */
import 'regenerator-runtime/runtime';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { Profile } from 'api/api-profile';
import { Messages } from 'api/api-messages';
import { Nux } from 'api/api-nux';
import { Entitlements } from 'api/api-entitlements';
import Payments from 'api/api-payments';
import { NavbarBody } from './navbar-body';
import SharedIntlProviderHOC from '../hocs/sharedIntlProviderHOC';
import get from "lodash/get";
import filter from "lodash/filter";
import Cookie from 'react-cookie';
import { Search } from '../api/api-search-server';
import { SearchWidget } from '../SearchWidget/SearchForm/SearchWidget';

export class Navbar extends Component {
  static emitUserUpdatedEvent (user) {
    const userUpdatedEvent = $.Event('userInfoUpdated');
    $(window).trigger(userUpdatedEvent, user);
  }

  static focus () {
    const navElement = $('#main-nav');
    const navTransparentClass = navElement.hasClass('navbar-transparent') ? 'navbar-transparent' : '';
    const navShowsLoggedIn = ('' === navElement.attr('data-loggedin'));
    const accessToken = PSSessions.Cookies('PSAccess');
    if (!accessToken) {
      if (navShowsLoggedIn) {
        ReactDOM.render(
          <Navbar
            loggedIn="hide"
            navTransparentClass={navTransparentClass}
            loggedOut=""
            locale={navJSON.locale}
            envLocaleData={navJSON.envLocaleData}
          />, document.getElementById('nav-container'));
      }
    }
  }

  static refreshUserInfo (onlyUserInfo, fromSignup, extraSignupAttrs) {
    // use cookie to refresh,
    let profile = null;
    let messageCount = null;
    let managedAccount = null;
    let hostStatusObject = null;
    let nuxData = null;
    const navElement = $('#main-nav');
    const navTransparentClass = navElement.hasClass('navbar-transparent') ? 'navbar-transparent' : '';
    // use cookie to refresh,
    const accessToken = PSSessions.Cookies('PSAccess');
    if (!accessToken) {
      return;
    }

    // #5
    function finalRender () {
      ReactDOM.render(
        <Navbar
          loggedIn=""
          userSSOID={profile.SSOid}
          messageCount={messageCount}
          isHost={profile.is_host}
          metaData={profile.metadata}
          avatarURL={profile.avatar_url}
          navTransparentClass={navTransparentClass}
          loggedOut="hide"
          managedAccount={managedAccount}
          externalAccountsError={profile.external_accounts_error}
          hostStatusObject={hostStatusObject}
          skCompleted={profile.sk_completed}
          nuxData={nuxData}
          searchActivity={navJSON.searchActivity}
          searchLocation={navJSON.searchLocation}
          displaySearchNav={navJSON.displaySearchNav}
          hideSearch={navJSON.hideSearch}
          locale={navJSON.locale}
          envLocaleData={navJSON.envLocaleData}
        />, document.getElementById('nav-container')
      );
    }

    function callNux () {
      Nux.read('trigger=page-load', accessToken, (nuxResponse) => {
        if (nuxResponse.error) return;
        nuxData = (nuxResponse || {}).data || [];
        finalRender();
      });
    }

    // #4
    function finalCallback (response) {
      if (response.error) {
        // what to do?
        return;
      }
      // response.thread_count
      messageCount = response.thread_count;
      if (profile.account_id) {
        managedAccount = {
          account_id: profile.account_id,
          payouts_enabled: profile.payouts_enabled
        }
      } else {
        managedAccount = false;
      }

      if (profile.is_host) {
        Payments.getBankStatusData(profile.SSOid, accessToken, (bankResponse) => {
          if (bankResponse.error) {
            return;
          }
          hostStatusObject = bankResponse;
          callNux();
        });
      } else {
        callNux();
      }
    }

    // #3.1
    function updateUserNavInfoAndGetMsgCount () {
      // render nav info because thread count return takes a while
      ReactDOM.render(
        <Navbar
          loggedIn=""
          userSSOID={profile.SSOid}
          metaData={profile.metadata}
          isHost={profile.is_host}
          avatarURL={profile.avatar_url}
          navTransparentClass={navTransparentClass}
          displaySearchNav={navJSON.displaySearchNav}
          hideSearch={navJSON.hideSearch}
          searchActivity={navJSON.searchActivity}
          searchLocation={navJSON.searchLocation}
          loggedOut="hide"
          locale={navJSON.locale}
          envLocaleData={navJSON.envLocaleData}
        />, document.getElementById('nav-container')
      );
      const msgPath = '/v1/messages/user/threads/count?is_read=false&to=' + profile.SSOid;
      // calls messages api
      Messages.read(msgPath, accessToken, finalCallback);
      Navbar.emitUserUpdatedEvent(profile);
    }
    // #3.2
    function updateUserNavInfo () {
      // render nav info
      ReactDOM.render(
        <Navbar
          loggedIn=""
          userSSOID={profile.SSOid}
          avatarURL={profile.avatar_url}
          navTransparentClass={navTransparentClass}
          displaySearchNav={navJSON.displaySearchNav}
          hideSearch={navJSON.hideSearch}
          searchActivity={navJSON.searchActivity}
          searchLocation={navJSON.searchLocation}
          loggedOut="hide"
          locale={navJSON.locale}
          envLocaleData={navJSON.envLocaleData}
        />, document.getElementById('nav-container')
      );
    }

    // #2
    function profileCallback (response) {
      if (response.error) {
        // what to do?
        return;
      }

      profile = response;
      const promo = PSSessions.Cookies('promo');
      const promoId = PSSessions.Cookies('promo-id');

      const preferredLocale = get(profile, 'preferred_locale', '');
      const envLocaleMap = SharedIntlProviderHOC.getEnvLocaleData();
      const urlLocale = get(envLocaleMap, `${preferredLocale}.url_prefix`,''); //Get url_locale based on the profile preferred_locale.
      const localeCookie = Cookie.load('preferred_locale');
      // return logged in navbar

      if (!localeCookie || (preferredLocale !== localeCookie)) {
        Cookie.save('preferred_locale', preferredLocale, {
          path: '/',
          expires: new Date((Date.now()) + (60 * 60 * 6 * 1000)),
          domain: window.location.host,
          secure: -1 !== window.location.protocol.indexOf('s'),
        });
      }

      profile.entitlement_external_id = promo;
      profile.entitlement_id = promoId;

      if (profile.avatar_id) {
        profile.avatar_url = `https://img.peerspace.com/image/upload/c_crop,g_custom/v1504032608/${profile.avatar_id}.jpg`;
      }

      if (onlyUserInfo) {
        updateUserNavInfo();
        if (fromSignup) {
          // from signup
          analyticsIntegrations.signupForm('account created', extraSignupAttrs, profile);
          if (window.dataLayer) {
            window.dataLayer.push({ 'event': 'gtmsignup' });
          }
          if (PSSessions.Cookies('host-ref-promo')) {
            PSSessions.Cookies.expire('host-ref-promo');
            PSSessions.Cookies.expire('host-ref-promo-user-id');
          }
        }
      } else {
        updateUserNavInfoAndGetMsgCount();
      }
      PSSessions.Cookies.set('PSUser', profile.SSOid);

      Entitlements.readUserEntitlement(profile.SSOid, accessToken, (attachmentsResponse) => {
        const attachmentsCollection = attachmentsResponse.attachments;
        if (attachmentsCollection && attachmentsCollection.length) {
          const attachment = filter(attachmentsCollection, 'active');
          const currentPromo = attachment[0].entitlement;
          console.log('got some attachments, updating cookie if it\'s new');
          if (promo !== currentPromo.external_id) {
            PSSessions.Cookies.set('promo', currentPromo.external_id, { expires: new Date(currentPromo.end) });
            PSSessions.Cookies.set('promo-id', currentPromo._id, { expires: new Date(currentPromo.end) });
          }
        } else if (promo) {
          Entitlements.readEntitlement(promo, (entitlementResponse) => {
            if (entitlementResponse.error) {
              return;
            }

            Entitlements.createAttachment(entitlementResponse._id, profile.SSOid, accessToken, () => {
              console.log('Attachment created!');
            });
          });
        }
      });
    }

    // #1
    // Calls profiles api
    const profilePath = '/v1/profiles/me';
    Profile.read(profilePath, accessToken, profileCallback);
  }

  constructor (props) {
    super(props);
    this.state = {
      availablePermalinks: {},
      displaySearchWidget: false
    };
  }

  componentDidMount () {
    // the loggedOut prop actually checks for presence of a 'hide' class
    // on the logged out view of the navbar
    if (this.props.loggedOut) {
      Navbar.refreshUserInfo();
    } else {
      const { envLocaleData, locale } = this.props;
      const urlPrefix = envLocaleData && envLocaleData[locale] && envLocaleData[locale].url_prefix || '';
      const filterPermalinks = (linkObjs) => {
        return linkObjs.map(o => o.permalink).filter(
          (link) => link.startsWith(`/${urlPrefix}`)
        );
      }
      Search.getAvailablePermalinks().then((response) => {
        const availablePermalinks = Object.keys(response).reduce((links, key) => {
          if (response[key].error) {
            console.error('navbar.componentDidMount', response[key].error);
            links[key] = [];
            return links;
          }
          links[key] = filterPermalinks(response[key]);
          return links;
        }, {})
        this.setState({ availablePermalinks });
      }).catch((error) => {
        console.error('navbar.componentDidMount', error);
      });
    }
  }

  shouldComponentUpdate (nextProps) {
    const accessToken = PSSessions.Cookies('PSAccess');
    if (nextProps.messageCount && !accessToken) {
      return false;
    }
    return true;
  }

  render () {
    const navbarBodyProps = {
      availablePermalinks: this.state.availablePermalinks,
      ...this.props
    };
    return (
      <SharedIntlProviderHOC locale={this.props.locale} envLocaleData={this.props.envLocaleData}>
        <>
          <NavbarBody
            {...navbarBodyProps}
            toggleSearchWidgetFn={ () => this.setState({ displaySearchWidget: !this.state.displaySearchWidget })}
          />
          <SearchWidget
            {...this.props}
            displaySearchWidget={this.state.displaySearchWidget}
            closeSearchWidgetFn={ () => this.setState({ displaySearchWidget: false })}
          />
        </>
      </SharedIntlProviderHOC>
    );
  }
}

exports.Navbar = Navbar;

Navbar.defaultProps = {
  navTransparentClass: ''
};

Navbar.propTypes = {
  locale: PropTypes.string,
  envLocaleData: PropTypes.object,
  messageCount: PropTypes.number,
  loggedOut: PropTypes.string
};
